/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Hero_Cta2Inputs */

const en_hub_hero_cta2 = /** @type {(inputs: Hub_Hero_Cta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the docs`)
};

const id_hub_hero_cta2 = /** @type {(inputs: Hub_Hero_Cta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca dokumentasi`)
};

/**
* | output |
* | --- |
* | "Read the docs" |
*
* @param {Hub_Hero_Cta2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_hero_cta2 = /** @type {((inputs?: Hub_Hero_Cta2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Hero_Cta2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_hero_cta2(inputs)
	return en_hub_hero_cta2(inputs)
});